/* eslint-disable */
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import validator from 'validator';
import { Post } from '../../Axios/AxiosFunctions';
import Button from '../../Component/Button/Button';
import CustomPhoneInput from '../../Component/CustomPhoneInput';
import Input from '../../Component/Input/Input';
import { Radio } from '../../Component/Radio/Radio';
import ModalSkeleton from '../ModalSkeleton';
import classes from './EmailAgentModal.module.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AiOutlineNumber } from 'react-icons/ai';
import { BiBuildingHouse } from 'react-icons/bi';
import { BsGrid3X3Gap } from 'react-icons/bs';
import { MdLocationOn, MdOutlineBathtub, MdOutlineHotel } from 'react-icons/md';
import { RiHotelFill } from 'react-icons/ri';
import { TbCalendarTime } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Captcha from '../../Component/Captcha';
import Checkbox from '../../Component/Checkbox/Checkbox';
import IconList from '../../Component/IconList/IconList';
import TextArea from '../../Component/TextArea';
import Tooltip from '../../Component/Tooltip';
import { BaseURL, apiHeader, imageUrl } from '../../config/apiUrl';
import { m2ToFt2, usdToOther } from '../../utils/helpers';
import SuccessModal from '../SuccessModal';
import { Area, Bath, building, mapPin, Rooms, FloorIcon } from '../../constant/imagePath';

const EmailAgentModal = ({
  show,
  setShow,
  type = 'property',
  data,
  title = '',
  inquiryType // message, inquiry
}) => {
  const { t } = useTranslation('webCommon');
  const { accessToken, user } = useSelector((state) => state.authReducer);

  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { currency, areaUnit } = useSelector((state) => state.converterReducer);

  const [reason, setReason] = useState(
    `${t('propertyDetailAgentCard.reasonHalf')} ${type} ${t('propertyDetailAgentCard.reasonFull')}`
  );

  const [email, setEmail] = useState(user?.email || '');
  const [name, setName] = useState(
    `${user?.firstName !== undefined ? user?.firstName : ''} ${
      user?.lastName !== undefined ? user?.lastName : ''
    }`
  );
  const [phone, setPhone] = useState('');
  const [contactMethod, setContactMethod] = useState('Email');
  const [isLoading, setIsLoading] = useState(false);
  const [isCaptcha, setIsCaptcha] = useState(false);
  const [isAccept, setIsAccept] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);

  const handleSend = async () => {
    const url = BaseURL('inquiry/create');

    const params = {
      type,
      entity: data?._id,
      message: reason,
      name,
      email,
      phone,
      preferredContactMethod: contactMethod,
      isCaptcha,
      isAccept,
      ...(inquiryType && { inquiryType })
    };

    const getFieldName = (key = '') => {
      if (key === 'isCaptcha') return t('webFooter.captcha');
      if (key === 'isAccept') return t('webFooter.termsAndConditions');
      return key;
    };

    for (let key in params) {
      if (!params[key]) {
        if (key === 'phone') continue;

        return toast.error(
          `${t('propertyDetailAgentCard.form.getFieldHalf')} ${getFieldName(key)} ${t(
            'propertyDetailAgentCard.form.getFieldFull'
          )}`
        );
      }
    }

    if (!validator.isEmail(email)) {
      return toast.error(t('propertyDetailAgentCard.form.validEmail'));
    }

    setIsLoading(true);

    try {
      const response = await Post(url, params, apiHeader(accessToken));

      if (response) {
        toast.success(t('propertyDetailAgentCard.form.toastMessaged'));
        setReason(
          `${t('propertyDetailAgentCard.form.toastMessaged')} ${type} ${t(
            'propertyDetailAgentCard.form.contact'
          )}`
        );
        setEmail('');
        setName('');
        setPhone('');
        setIsAccept(false);
        setIsCaptcha(false);
        setContactMethod('Email');
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setShow(false);
    }
  };
  return (
    <>
      {show && (
        <ModalSkeleton
          width={'700px'}
          show={show}
          setShow={setShow}
          header={`Email ${title}`}
          headerClass={classes.header}
          modalStyle={classes.modal}
          modalClass={classes.body}>
          <style>{`.DropdownOptionContainer{
          text-transform:none;
        }`}</style>
          <Row className={classes.gap}>
            <Col md={12}>
              <Row className={[classes.propertyCard, 'gx-0'].join(' ')}>
                <Col md={5}>
                  <div className={classes.imgDiv}>
                    <img src={imageUrl(data?.images[0])} />
                  </div>
                </Col>
                <Col md={7}>
                  <div className={classes.rightCol}>
                    <div className={classes.detailInfo}>
                      <div className={classes.titleHeader}>
                        <p className={classes.tagline}>{data?.title?.[selectedLanguage]}</p>
                        <img src={imageUrl(data?.assignedAgent?.photo)} alt="profileImg" />
                      </div>

                      <div className={classes.addressWrap}>
                        {/* <MdLocationOn fill="var(--secondary-clr)" /> */}
                        <img src={mapPin} alt="mapPin" className={classes.mapPin} />
                        <p>{data?.address}</p>
                      </div>

                      <div className={classes.propertyDetailWrap}>
                        <Row className={classes.iconsRow}>
                          {type == 'event' && (
                            <>
                              <Col md={12} className={classes.propertyDetail}>
                                <Tooltip text={t('eventCard.tooltips.eventType')}>
                                  <img src={building} alt="building" />
                                </Tooltip>
                                <p>{data?.eventType?.title?.[selectedLanguage]}</p>
                              </Col>
                              <Col md={6} className={classes.propertyDetail}>
                                <Tooltip text={t('eventCard.tooltips.date')}>
                                  <TbCalendarTime color="var(--text-dark-gray-clr)" />
                                </Tooltip>
                                <p>{moment(data?.eventDate).format('ll')}</p>
                              </Col>
                            </>
                          )}
                          {type == 'project' && (
                            <>
                              <Col md={12} className={classes.propertyDetail}>
                                <Tooltip text={t('projectCard.tooltips.projectType')}>
                                  <img src={building} alt="building" />
                                </Tooltip>
                                <p>{data?.projectType?.title?.[selectedLanguage]}</p>
                              </Col>
                              <Col md={6} className={classes.propertyDetail}>
                                <IconList
                                  className={classes.infoIcons}
                                  Icon={AiOutlineNumber}
                                  label={t('projectCard.tooltips.noOfUnits')}
                                  value={data?.noOfUnits || '5'}
                                />
                              </Col>
                              <Col md={6} className={classes.propertyDetail}>
                                <IconList
                                  className={classes.infoIcons}
                                  Icon={TbCalendarTime}
                                  label={t('projectCard.tooltips.deliveryDate')}
                                  value={moment(data?.deliveryDate).format('ll')}
                                />
                              </Col>
                            </>
                          )}
                          {type == 'property' && (
                            <>
                              <Col md={12} className={classes.propertyDetail}>
                                <div className={classes.iconDivTwo}>
                                  <Tooltip text={t('propertyCard.tooltips.propertyPurpose')}>
                                    <img src={building} alt="building" />
                                  </Tooltip>
                                  <p className="p12">{t('propertyCard.tooltips.propertyType')}</p>
                                </div>
                              </Col>
                              <Col md={12}>
                                <div className={classes.propertyDetailWrapTwo}>
                                  <div className={classes.iconDiv}>
                                    <Tooltip text={t('propertyCard.tooltips.level')}>
                                      <img src={FloorIcon} alt="floors" />
                                    </Tooltip>
                                    <p className="p12">{`${data?.floorLevel?.en}`}</p>
                                  </div>
                                  <div className={classes.iconDiv}>
                                    <Tooltip
                                      text={t('propertyCard.tooltips.area') + ` (${areaUnit})`}>
                                      <img src={Area} alt="area" />
                                    </Tooltip>
                                    <p className="p12">{`${m2ToFt2({
                                      area: data?.netArea,
                                      unit: false
                                    })}`}</p>
                                  </div>

                                  <div className={classes.iconDiv}>
                                    <Tooltip text={t('propertyCard.tooltips.bathrooms')}>
                                      <img src={Bath} alt="bathroom" />
                                    </Tooltip>
                                    <p className="p12">{`${data?.noOfBathrooms}`}</p>
                                  </div>
                                  <div className={classes.iconDiv}>
                                    <Tooltip text={t('propertyCard.tooltips.rooms')}>
                                      <img src={Rooms} alt="rooms" />
                                    </Tooltip>
                                    <p className="p12">{data?.noOfRooms?.[selectedLanguage]}</p>
                                  </div>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                    {type == 'property' ? (
                      <h6 className={classes.price}>
                        {usdToOther({ amount: data?.price, ...currency })}
                        {data?.propertyPurpose?.en == 'Rent' && (
                          <span>{t('propertyCard.perMonth')}</span>
                        )}
                      </h6>
                    ) : (
                      <>
                        <h5>
                          {type == 'project'
                            ? data?.name?.[selectedLanguage]
                            : data?.title?.[selectedLanguage]}
                        </h5>
                        <h6 className={classes.price}>$ {data?.price}</h6>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>

            <Col md={12} className={classes.TextAreaDiv}>
              <TextArea
                className={classes.textAreaClass}
                value={reason}
                setValue={setReason}
                placeholder={t('textareaMessage')}
              />
            </Col>

            <Col md={6} className={classes.TextAreaDiv}>
              <Input
                inputStyle={{
                  borderRadius: '5px'
                }}
                value={name !== undefined ? name : ''}
                setValue={setName}
                placeholder={`${t('reportListingModal.namePlaceholder')}*`}
              />
            </Col>
            <Col md={6} className={classes.TextAreaDiv}>
              <Input
                value={email}
                setValue={setEmail}
                inputStyle={{
                  borderRadius: '5px'
                }}
                placeholder={`${t('reportListingModal.emailPlaceholder')}*`}
                type="email"
              />
            </Col>

            <Col md={6} className={classes.phoneDiv}>
              <CustomPhoneInput
                value={phone}
                setter={setPhone}
                placeholder={`${t('reportListingModal.phonePlaceholder')}*`}
              />
            </Col>
            <Col md={6} className={classes.contactWrap}>
              <p>{`${t('reportListingModal.preferredMethod')} *`}</p>
              <div className={classes.methodWrap}>
                <Radio
                  value={contactMethod}
                  setValue={setContactMethod}
                  label={t('reportListingModal.email')}
                  variant="primary"
                />
                <Radio
                  value={contactMethod}
                  setValue={setContactMethod}
                  label={t('reportListingModal.phone')}
                  variant="primary"
                />
                <Radio
                  value={contactMethod}
                  setValue={setContactMethod}
                  label={t('reportListingModal.whatsapp')}
                  variant="primary"
                />
              </div>
            </Col>

            <Col md={12}>
              <Captcha setValue={setIsCaptcha} />
            </Col>
            <Col md={12}>
              <Checkbox
                label={t('reportListingModal.checkbox')}
                value={isAccept}
                setValue={setIsAccept}
              />
            </Col>
            <Col md={12}>
              <Button
                className={classes.btn}
                onClick={handleSend}
                label={
                  isLoading
                    ? t('reportListingModal.btnTextLoading')
                    : t('reportListingModal.btnText')
                }
              />
            </Col>
          </Row>

          {/* <div className={classes.footer}>
        <p>Don’t have a free account yet? </p>
        <p>Create your free account now</p>
      </div> */}
        </ModalSkeleton>
      )}
      {/* {isSuccess && (
        <SuccessModal
          t={t}
          title={t('propertyDetailAgentCard.successModal.success')}
          show={isSuccess}
          setShow={setIsSuccess}
        />
      )} */}
    </>
  );
};

export default EmailAgentModal;
